module.exports = __webpack_public_path__ + "img/activate_banner.af5c20c8.png";